import { VNTRANSACTIONS_CLEAR_CARD_DATA, VNTRANSACTIONS_SET_CARD_DATA, VNTRANSACTIONS_SET_ORDER_DATA } from './ActionTypes'

/**
 * Set Recovered Card Data
 * This is sent from Android and it's accessible only once
 *
 * @param {Object} data
 * @returns
 */
export function setRecoveryData(data) {
  return (dispatch) => {
    dispatch({
      type: VNTRANSACTIONS_SET_CARD_DATA,
      data,
    })
  }
}

/**
 * Clear Transaction Card Data
 *
 * @returns
 */
export function clearRecoveryData() {
  return (dispatch) => {
    dispatch({
      type: VNTRANSACTIONS_CLEAR_CARD_DATA,
    })
  }
}

/**
 * Set current transaction's order data
 *
 * @param {String} uuid
 * @param {String} orderNumber
 * @param {String} paymentId
 * @param {String} attendantId
 * @param {?Number} tipAmountInCents
 * @param {?Number} tenderAmountInCents
 * @param {?Number} balanceDueInCents
 * @param {?Array} payments
 * @param {?Boolean} hasTipApplied
 * @param {?String} signature
 * @param {?Boolean} isAuthorization
 * @param {?Array} lineItems - Cart Line Items for Tabs (order does not exist yet)
 *
 * @returns {Function} A thunk action that dispatches the order data.
 */
export function setOrderDataForTransaction(
  uuid,
  orderNumber,
  paymentId,
  attendantId,
  tipAmountInCents = 0,
  tenderAmountInCents = 0,
  balanceDueInCents = 0,
  payments = [],
  hasTipApplied = false,
  signature = null,
  isAuthorization = false,
  lineItems = [],
  charityAmountInCents = 0,
) {
  return (dispatch) => {
    dispatch({
      type: VNTRANSACTIONS_SET_ORDER_DATA,
      data: {
        uuid,
        orderNumber,
        paymentId,
        attendantId,
        signature,
        tipAmountInCents,
        tenderAmountInCents,
        balanceDueInCents,
        payments,
        hasTipApplied,
        isAuthorization,
        lineItems,
        charityAmountInCents,
      },
    })
  }
}
